import type { Terminal } from 'lucide-react';

/**
 * What a tool or an app is shown by, in the theme's ink like every glyph: a surface of the core
 * by its `icon`, an app by its own icon (`display.icon`), a template image painted through a
 * mask, never shown as is (only its shape counts, and its SVG never runs).
 */
export function ItemIcon({
  icon: Icon,
  src,
  className = 'size-4',
}: {
  icon: typeof Terminal;
  src?: string | undefined;
  className?: string;
}) {
  if (src === undefined) return <Icon className={`shrink-0 ${className}`} />;
  return (
    <span
      aria-hidden
      className={`shrink-0 bg-current ${className}`}
      style={{
        maskImage: `url("${src}")`,
        maskPosition: 'center',
        maskRepeat: 'no-repeat',
        maskSize: 'contain',
      }}
    />
  );
}
